module.exports = __webpack_public_path__ + "img/logo_coin98.b4c62ed8.png";